import React, {useState, useEffect} from 'react';


import i18n from 'live/services/i18n';
import styled from 'styled-components';
import FilterDropdown from 'live/components/forms/ui/filter-dropdown';
import { Lookup, Parameter } from '../../types';
import './style.scss';

type Props = {
    values: Parameter[]
    callback(paramter: Parameter): void
}

const DropdownParameters = ({values = [], callback}: Props): JSX.Element => {
    const [parameterActive, setParameterActive] = useState<Parameter>()
    const [ open, setOpen] = useState<boolean>(false)

    const applyparameters = (parameter: Parameter) => {
        setParameterActive(parameter)
        callback(parameter)
    }

    const findParameterDefault = (): Parameter => {
        return values.find(ele => ele.default === true)
    }

    useEffect(() => {
        if(values.length > 0 && !parameterActive) setParameterActive(findParameterDefault())
    }, [values])

    return <FilterDropdown        
                onClick={() => setOpen(!open)}
                hideTitle={true} disableTooltip={true}
                containerClassName="smart-mobility-dropdown-parameters"        
                btnLabel={
                    <WrapperBtn>
                        <span className='wrapper-btn-title'>{i18n('On map')}:</span>
                        <span data-testid="reference-line-active" className='wrapper-btn-reference-line'>{parameterActive?.title}</span>
                        <i className={`fas fa-caret-${open ? 'up' : 'down'}`}></i>
                    </WrapperBtn>
                }>
                
                <Wrapper>
                    {
                        values.map((val, index) => {
                            const {id, title} = val
                            return <Item data-testid={"teste-reference-line-" + index} key={index} onClick={(ele) => applyparameters(val)}>
                                {title}
                            </Item>
                        })
                    }
                </Wrapper>
            </FilterDropdown>
}

export default DropdownParameters

const Wrapper = styled.div``

const WrapperBtn = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    font-family: ${({theme}) => theme['font-semibold']};

    .wrapper-btn-title{
        color: ${({theme}) => theme['gray-600']};
        margin-right: 8px;
    }

    .wrapper-btn-reference-line{
        margin-right: 8px;
    }

    .wrapper-btn-reference-line, i{
        color: ${({theme}) => theme['blue-500']};
    }
`

const Item = styled.div`
    cursor: pointer;
    font-size: 16px;
    font-family: ${({theme}) => theme['font-regular']};
    padding: 12px 16px;
    line-height: 16px;
    color: ${({theme}) => theme['gray-700']};

    &:hover{
        background-color: ${({theme}) => theme['blue-200']};
    }
`